import { atom } from "recoil";

//stores the payload received from the event via websocket
export const visitUpdated = atom({
  key: "visitUpdated",
  default: {},
}); 
